var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('gl-sprintf',{attrs:{"message":_vm.message},scopedSlots:_vm._u([{key:"bold",fn:function({ content }){return [_c('span',{staticClass:"gl-font-weight-bold",domProps:{"textContent":_vm._s(content)}})]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }